import type { LinkType } from '../types';

type HookReturnType = ModelHookResult<{
	href: string;
	linkTextTranslationKey: string;
}>;

const LINK_TEXT_KEYS: Record<LinkType, string> = {
	signatures: 'signatures_link_text',
	comments: 'comments_link_text',
	promotions: 'promotions_link_text',
};

function getLinkTextKey(linkType?: LinkType): string {
	if (!linkType) {
		return 'link_text';
	}

	return LINK_TEXT_KEYS[linkType];
}

export function usePetitionActivityLink({ slug, linkType }: { slug: string; linkType?: LinkType }): HookReturnType {
	const linkTextTranslationKey = getLinkTextKey(linkType);

	return {
		data: {
			linkTextTranslationKey,
			href: `/p/${encodeURIComponent(slug)}/activity/${linkType ?? ''}`,
		},
	};
}
